import React from "react";

/**
 * Landing page founder card — appears once, quietly, between hero and
 * "What lives inside." Warm, not braggy. See /app/memory/PRD.md for the
 * copy sign-off with the actual founder.
 */
export default function FounderCard() {
  return (
    <section
      data-testid="founder-card"
      className="w-full bg-[#FBF6EE] border-y border-[#EAE3D2]"
      aria-labelledby="founder-card-title"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-10 py-14 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-8 md:gap-12 items-start">
          {/* Portrait */}
          <div className="mx-auto md:mx-0">
            <div className="relative w-[168px] h-[168px] sm:w-[200px] sm:h-[200px]">
              <div className="absolute inset-0 rounded-full bg-[#D4A574]/25 blur-2xl" />
              <img
                src="/jim-400.jpg"
                srcSet="/jim-400.jpg 1x, /jim-800.jpg 2x"
                alt="Jim Canfield, founder of Colleague"
                width="200"
                height="200"
                loading="lazy"
                className="relative w-full h-full object-cover rounded-full ring-4 ring-white shadow-xl"
              />
            </div>
          </div>

          {/* Copy */}
          <div className="max-w-2xl">
            <p
              id="founder-card-title"
              className="text-xs uppercase tracking-[0.3em] text-[#9A938A] mb-3"
            >
              A note from Jim, who built Colleague
            </p>
            <div className="space-y-4 text-[15px] sm:text-base leading-relaxed text-[#3D3833]">
              <p>
                Over 10,000 hours coaching more than 300 CEOs taught me one
                thing:{" "}
                <span className="italic text-[#2D2926]">
                  most people don&apos;t get access to a great coach on the day
                  they actually need one.
                </span>
              </p>
              <p>
                I&apos;ve had the privilege of building programs and content
                alongside people like Tony Hsieh, Chip Conley, Marshall
                Goldsmith, and Jack Stack. Three times my peers at Vistage
                named me Speaker of the Year — US, UK, and Worldwide. My book,{" "}
                <em>CEO Tools 2.0</em>, distills two decades of these
                frameworks — and Colleague brings them to life, on demand.
              </p>
              <p>
                This is my attempt to make that kind of coaching available to
                everyone, on the days it matters.
              </p>
            </div>
            <div className="mt-6 flex items-baseline gap-3 flex-wrap">
              <p className="font-serif text-xl text-[#2D2926]">Jim Canfield</p>
              <p className="text-sm text-[#6B655D]">
                author,{" "}
                <a
                  href="https://www.amazon.com/CEO-Tools-2-0-System-Manage/dp/0997521074/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="founder-card-book-link"
                  className="italic text-[#2D2926] hover:text-[#C29260] underline underline-offset-4"
                >
                  CEO Tools 2.0
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
